import { useContext } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { applicationContext } from "helpers/services";
import Clickable from "./Clickable";
import { dashboardContext } from "./DashboardContext";
import { useIntl } from "react-intl";
import { LocalizationIds } from "helpers/Localizations";
import { localeManagerContext } from "helpers/Locale";

let ByStatusDashboard = () => {
    let { formatMessage } = useIntl();
    let { currentLocale } = useContext(localeManagerContext)
    let { ticketStatuses, ticketCategories } = useContext(applicationContext)
    let { byStatusDashboard } = useContext(dashboardContext)

    return (
        <>
            <Typography variant="h5">{formatMessage({ id: LocalizationIds.DashboardByCategoryAndStatus })}</Typography>

            <Table size="small">
                <TableHead>
                    <TableRow >
                        <TableCell>{formatMessage({ id: LocalizationIds.Status })}</TableCell >
                        {ticketCategories.map((x) =>
                            <TableCell key={x.ticketCategoryId} align="right">
                                {x.name[currentLocale]}
                            </TableCell>
                        )}
                        <TableCell align="right">{formatMessage({ id: LocalizationIds.Total })}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {ticketStatuses
                        .map((status) =>
                            <TableRow key={status.code} hover>
                                <TableCell component="th" scope="row">{status.descriptions[currentLocale]}</TableCell>
                                {ticketCategories.map((y) =>
                                    <TableCell key={y.ticketCategoryId} align="right">
                                        <Clickable
                                            value={byStatusDashboard.find(z => z.categoryId === y.ticketCategoryId && z.status === status.code)?.count || 0}
                                            categoryId={y.ticketCategoryId}
                                            status={status.code}
                                        />
                                    </TableCell>
                                )}
                                <TableCell align="right">
                                    <Clickable
                                        value={byStatusDashboard.filter((p => p.status === status.code)).sum((p) => p.count) || 0}
                                        status={status.code}
                                    />
                                </TableCell>
                            </TableRow>
                        )}
                    <TableRow hover>
                        <TableCell><b>{formatMessage({ id: LocalizationIds.Total })}</b></TableCell>
                        {ticketCategories.map(x =>
                            <TableCell key={x.ticketCategoryId} align="right">
                                <b>
                                    <Clickable
                                        value={byStatusDashboard.filter(p => p.categoryId === x.ticketCategoryId).sum(p => p.count) || 0}
                                        categoryId={x.ticketCategoryId}
                                    />
                                </b>
                            </TableCell>
                        )}
                        <TableCell align="right">
                            <b>
                                <Clickable value={byStatusDashboard.sum(p => p.count)} />
                            </b>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </>
    )
}

export default ByStatusDashboard;